// Libraries
import { useRouter } from 'next/router';
// Components
import { Grid } from 'ht-styleguide';
import ProductCardItem from 'src/components/Sku/ProductCards';
import { Sku } from 'src/types/sku.types';
// Utils
import priceFormatter from '../helpers';
import { skuPath } from '@constants/paths';

type ProductCardsProps = {
  skus: Sku[] | undefined;
  showCta: boolean;
  showHover?: boolean;
};
const ProductCards = ({ skus, showCta = false, showHover = false }: ProductCardsProps) => {
  if (!skus || !skus.length) return null;
  const router = useRouter();
  const handleClick = (seoName: string) => router.push(skuPath(seoName));
  return (
    <div className="paddingTop-medium1">
      <Grid.Fluid classes="marginAuto">
        <Grid.Row>
          <Grid.Column>
            <h4 className="n700 text-align-center marginBottom-medium1 text-weight-medium">Not getting the speed you need? We can help!</h4>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row classes="marginAuto paddingX-tiny1">
          {skus.map(sku => (
            <Grid.Column sm={4} md={4} lg={3} key={sku.id}>
              <ProductCardItem
                cheapestPrice={priceFormatter(sku)}
                startsAtPrice={sku.basePrice / 100}
                image={sku.heroMobileImageUrl}
                name={sku.name}
                ratingAttributes={sku.ratingAttributes}
                onClick={() => handleClick(sku.seoName)}
                showCta={showCta}
                showHover={showHover}
              />
            </Grid.Column>
          ))}
        </Grid.Row>
      </Grid.Fluid>
    </div>
  );
};

export default ProductCards;
